'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateActiveBidders = exports.nextLotOpened = exports.missive = exports.lotUnsold = exports.lotSold = exports.lotSkipped = exports.lotPassed = exports.lotClosed = exports.bidAccepted = exports.auctionStarted = exports.getLiveItemData = exports.getCatalogBidders = exports.getLiveCatalogData = exports.getCatalogMessages = exports.UPDATE_ACTIVE_BIDDERS = exports.NEXT_LOT_OPENED = exports.MISSIVE = exports.LOT_UNSOLD = exports.LOT_SOLD = exports.LOT_SKIPPED = exports.LOT_PASSED = exports.LOT_CLOSED = exports.BID_ACCEPTED = exports.AUCTION_STARTED = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _liveBid = require('./liveBid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ms from 'ms';
// import union from 'lodash/union';

/* Action Types */
var AUCTION_STARTED = exports.AUCTION_STARTED = 'AUCTION_STARTED';
// import difference from 'lodash/difference';
// import { getDeployment } from '../modules/config';
// import { CatalogDetail as api } from '../api';
var BID_ACCEPTED = exports.BID_ACCEPTED = 'BID_ACCEPTED';
var LOT_CLOSED = exports.LOT_CLOSED = 'LOT_CLOSED';
var LOT_PASSED = exports.LOT_PASSED = 'LOT_PASSED';
var LOT_SKIPPED = exports.LOT_SKIPPED = 'LOT_SKIPPED';
var LOT_SOLD = exports.LOT_SOLD = 'LOT_SOLD';
var LOT_UNSOLD = exports.LOT_UNSOLD = 'LOT_UNSOLD';
var MISSIVE = exports.MISSIVE = 'MISSIVE';
var NEXT_LOT_OPENED = exports.NEXT_LOT_OPENED = 'NEXT_LOT_OPENED';
var UPDATE_ACTIVE_BIDDERS = exports.UPDATE_ACTIVE_BIDDERS = 'UPDATE_ACTIVE_BIDDERS';

/* reducer */
var DEFAULT_STATE = {
    bidders: {},
    catalogs: {},
    items: {},
    messages: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var bidders = void 0;
    var catalogs = void 0;
    var items = void 0;
    var messages = void 0;

    switch (action.type) {
        case AUCTION_STARTED:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Auction Started',
                type: 'started'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        case BID_ACCEPTED:
            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || {};
            items[action.payload.itemId].leadingBid = action.payload.amount;
            items[action.payload.itemId].leadingBidder = action.payload.bidderId;

            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Bid Accepted $' + action.payload.amount,
                type: 'accepted'
            });

            return (0, _extends3.default)({}, state, {
                items: items,
                messages: messages
            });
        case LOT_CLOSED:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Lot ' + action.payload.itemId + ' Closed',
                type: 'closed'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        case LOT_PASSED:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Lot ' + action.payload.itemId + ' Passed',
                type: 'passed'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        case LOT_SKIPPED:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Lot ' + action.payload.itemId + ' Skipped',
                type: 'skipped'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        case LOT_SOLD:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Lot ' + action.payload.itemId + ' Sold',
                type: 'sold'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        case LOT_UNSOLD:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Lot ' + action.payload.itemId + ' Unsold',
                type: 'unsold'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        case MISSIVE:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: action.payload.missiveText,
                type: 'missive'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        case NEXT_LOT_OPENED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;

            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'Lot ' + action.payload.itemId + ' Opened',
                type: 'opened'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case UPDATE_ACTIVE_BIDDERS:
            bidders = (0, _cloneDeep2.default)(state.bidders);
            bidders[action.payload.catalogId] = action.payload.bidderCount;

            return (0, _extends3.default)({}, state, {
                bidders: bidders
            });
        case _liveBid.LIVE_BID_REQUEST:
            messages = (0, _cloneDeep2.default)(state.messages);
            messages[action.payload.catalogId] = messages[action.payload.catalogId] || [];
            messages[action.payload.catalogId].push({
                text: 'placed bid of ' + action.payload.bidAmount + ' on ' + action.payload.itemId,
                type: 'placed'
            });

            return (0, _extends3.default)({}, state, {
                messages: messages
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.console;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var biddersSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.bidders;
});
var catalogsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogs;
});
var itemsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.items;
});
var messagesSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.messages;
});

var getCatalogMessages = exports.getCatalogMessages = (0, _reselect.createSelector)([messagesSelector, idSelector], function (messages, id) {
    return (0, _cloneDeep2.default)(messages[id]) || [];
});

var getLiveCatalogData = exports.getLiveCatalogData = (0, _reselect.createSelector)([catalogsSelector, biddersSelector, idSelector], function (catalogs, bidders, id) {
    return (0, _extends3.default)({}, (0, _cloneDeep2.default)(catalogs[id]), { bidders: bidders[id] }) || { bidders: 1, currentItem: 0 };
});

var getCatalogBidders = exports.getCatalogBidders = (0, _reselect.createSelector)([biddersSelector, idSelector], function (bidders, id) {
    return bidders[id] || 1;
});

var getLiveItemData = exports.getLiveItemData = (0, _reselect.createSelector)([itemsSelector, idSelector], function (items, id) {
    return (0, _cloneDeep2.default)(items[id]) || { leadingBid: 10, leadingBidder: 0 };
});

/* ACTION CREATORS */
var auctionStarted = exports.auctionStarted = function auctionStarted(_ref) {
    var catalogId = _ref.catalogId;
    return {
        payload: { catalogId: catalogId },
        type: AUCTION_STARTED
    };
};

var bidAccepted = exports.bidAccepted = function bidAccepted(_ref2) {
    var catalogId = _ref2.catalogId,
        itemId = _ref2.itemId,
        amount = _ref2.amount,
        bidderId = _ref2.bidderId;
    return {
        payload: { amount: amount, bidderId: bidderId, catalogId: catalogId, itemId: itemId },
        type: BID_ACCEPTED
    };
};

var lotClosed = exports.lotClosed = function lotClosed(_ref3) {
    var catalogId = _ref3.catalogId,
        itemId = _ref3.itemId;
    return {
        payload: { catalogId: catalogId, itemId: itemId },
        type: LOT_CLOSED
    };
};

var lotPassed = exports.lotPassed = function lotPassed(_ref4) {
    var catalogId = _ref4.catalogId,
        itemId = _ref4.itemId;
    return {
        payload: { catalogId: catalogId, itemId: itemId },
        type: LOT_PASSED
    };
};

var lotSkipped = exports.lotSkipped = function lotSkipped(_ref5) {
    var catalogId = _ref5.catalogId,
        itemId = _ref5.itemId;
    return {
        payload: { catalogId: catalogId, itemId: itemId },
        type: LOT_SKIPPED
    };
};

var lotSold = exports.lotSold = function lotSold(_ref6) {
    var catalogId = _ref6.catalogId,
        itemId = _ref6.itemId;
    return {
        payload: { catalogId: catalogId, itemId: itemId },
        type: LOT_SOLD
    };
};

var lotUnsold = exports.lotUnsold = function lotUnsold(_ref7) {
    var catalogId = _ref7.catalogId,
        itemId = _ref7.itemId;
    return {
        payload: { catalogId: catalogId, itemId: itemId },
        type: LOT_UNSOLD
    };
};

var missive = exports.missive = function missive(_ref8) {
    var catalogId = _ref8.catalogId,
        missiveText = _ref8.missiveText;
    return {
        payload: { catalogId: catalogId, missiveText: missiveText },
        type: MISSIVE
    };
};

var nextLotOpened = exports.nextLotOpened = function nextLotOpened(_ref9) {
    var catalogId = _ref9.catalogId,
        itemId = _ref9.itemId;
    return {
        payload: { catalogId: catalogId, itemId: itemId },
        type: NEXT_LOT_OPENED
    };
};

var updateActiveBidders = exports.updateActiveBidders = function updateActiveBidders(_ref10) {
    var bidderCount = _ref10.bidderCount,
        catalogId = _ref10.catalogId;
    return {
        payload: { bidderCount: bidderCount, catalogId: catalogId },
        type: UPDATE_ACTIVE_BIDDERS
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/console.js
// module id = FSAu
// module chunks = 46